import { StyleSheet } from 'react-native';
import theme from 'shared/styles/theme';

import { CardType } from './BrazeCard.constants';

export const getCardTypeStyle = (
  cardType: CardType,
  pressed: boolean,
  isHovered: boolean,
  isFocused: boolean,
) => {
  if (pressed) {
    switch (cardType) {
      case CardType.Sky:
        return pressedBackgroundColor.skyPressedBackground;
      case CardType.Orchid:
        return pressedBackgroundColor.orchidPressedBackground;
      case CardType.Blush:
        return pressedBackgroundColor.blushPressedBackground;
      case CardType.Sand:
        return pressedBackgroundColor.sandPressedBackground;
    }
  } else if (isHovered) {
    switch (cardType) {
      case CardType.Blush:
        return hoverBackgroundColor.blushHoverBackground;
      case CardType.Orchid:
        return hoverBackgroundColor.orchidHoverBackground;
      case CardType.Sand:
        return hoverBackgroundColor.sandHoverBackground;
      case CardType.Sky:
        return hoverBackgroundColor.skyHoverBackground;
    }
  } else if (isFocused) {
    switch (cardType) {
      case CardType.Blush:
        return focusedBackgroundColor.blushFocusedBackground;
      case CardType.Orchid:
        return focusedBackgroundColor.orchidFocusedBackground;
      case CardType.Sand:
        return focusedBackgroundColor.sandFocusedBackground;
      case CardType.Sky:
        return focusedBackgroundColor.skyFocusedBackground;
    }
  } else {
    switch (cardType) {
      case CardType.Blush:
        return defaultBackgroundColor.blushDefaultBackground;
      case CardType.Orchid:
        return defaultBackgroundColor.orchidDefaultBackground;
      case CardType.Sand:
        return defaultBackgroundColor.sandDefaultBackground;
      case CardType.Sky:
        return defaultBackgroundColor.skyDefaultBackground;
    }
  }
};

export const defaultBackgroundColor = StyleSheet.create({
  blushDefaultBackground: {
    backgroundColor: theme.color.expressive.blush,
  },
  orchidDefaultBackground: {
    backgroundColor: theme.color.expressive.orchid,
  },
  sandDefaultBackground: {
    backgroundColor: theme.color.expressive.sand,
  },

  skyDefaultBackground: {
    backgroundColor: theme.color.expressive.sky,
  },
});

export const focusedBackgroundColor = StyleSheet.create({
  blushFocusedBackground: {
    backgroundColor: theme.color.expressive.blushHover,
    borderColor: theme.color.border.focused,
    borderWidth: 1,
  },
  orchidFocusedBackground: {
    backgroundColor: theme.color.expressive.orchidHover,
    borderColor: theme.color.border.focused,
    borderWidth: 1,
  },
  sandFocusedBackground: {
    backgroundColor: theme.color.expressive.sandHover,
    borderColor: theme.color.border.focused,
    borderWidth: 1,
  },

  skyFocusedBackground: {
    backgroundColor: theme.color.expressive.skyHover,
    borderColor: theme.color.border.focused,
    borderWidth: 1,
  },
});

export const hoverBackgroundColor = StyleSheet.create({
  blushHoverBackground: {
    backgroundColor: theme.color.expressive.blushHover,
  },
  orchidHoverBackground: {
    backgroundColor: theme.color.expressive.orchidHover,
  },
  sandHoverBackground: {
    backgroundColor: theme.color.expressive.sandHover,
  },
  skyHoverBackground: {
    backgroundColor: theme.color.expressive.skyHover,
  },
});

export const pressedBackgroundColor = StyleSheet.create({
  blushPressedBackground: {
    backgroundColor: theme.color.expressive.blushPressed,
  },
  orchidPressedBackground: {
    backgroundColor: theme.color.expressive.orchidPressed,
  },
  sandPressedBackground: {
    backgroundColor: theme.color.expressive.sandPressed,
  },
  skyPressedBackground: {
    backgroundColor: theme.color.expressive.skyPressed,
  },
});
